import api from 'api';

export const loadShare = api('GET /api/gallery-creatives/:id/share');

export const updateShare = api('PUT /api/gallery-creatives/:id/share');
